import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import { TransferItemUITypes } from '@app/transfer-bundle/constant/transfer-item-types';
import DirectoryWrapper from '@component/preview/directory-wrapper';
import Icon from '@component/icon';
import Spinner from '@component/spinner';
import GridAction from '@component/preview/grid-action';
import FileWrapper from '@component/preview/file-wrapper';
import Loader from '@component/loader';
import { PORCELAIN } from '@constant/colors';

const GridItem = ({ item, onDownload, onItemClick, scrollElement }) => {
  if (item.uiType === TransferItemUITypes.directory) {
    // Downloading separate folders is not supported yet,
    // thus actual action is replaced with an empty `span`.
    // ToDo: implement selective folders download asap,
    //  remove this ugly workaround

    const action = { alternativeAction: <span className="grid__action" /> };

    return (
      <DirectoryWrapper
        key={item.name}
        title={item.name}
        action={action}
        className="grid__card"
        insideGrid
      />
    );
  }

  let icon = <Icon type="DownloadSmall" />;
  if (get(item, 'file.state.download') === 'downloading') {
    icon = (
      <Spinner
        rotate={true}
        percentage={25}
        hideText
        circumference={24}
        stroke={2}
      />
    );
  }

  if (item.file && item.file.state && item.file.state.download === 'done') {
    icon = <Icon type="CheckCircle" />;
  }

  const action = {
    alternativeAction: (
      <GridAction onClick={onDownload} item={item}>
        {icon}
      </GridAction>
    ),
  };

  const loader = (
    <Loader animation={false} backgroundColor={PORCELAIN} pulseEnabled={true} />
  );

  return (
    <FileWrapper
      key={item.id}
      item={item}
      action={action}
      loadingIndicator={loader}
      onClick={onItemClick}
      scrollEl={scrollElement}
      errorAction={false}
      className="grid__card"
    />
  );
};

GridItem.propTypes = {
  item: PropTypes.object.isRequired,
  onDownload: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  scrollElement: PropTypes.object.isRequired,
};

export default GridItem;
